<template>
  <el-table-column
    prop="customers"
    label="Átvevevők"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.customers && scope.row.customers.length"
        v-for="customer in scope.row.customers"
      >
        {{ customer.name }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customers',
};
</script>
